import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const EmployeesTable = ({
  employees,
  totalRecords,
  onPage,
  onSort,
  onFilter,
  lazyParams,
  loading,
  actionBodyTemplate
}) => {
  return (
    <div className="min-h-0">
      <DataTable value={employees} paginator lazy totalRecords={totalRecords} onPage={onPage} onSort={onSort} onFilter={onFilter}
        first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[5, 10, 25]} responsiveLayout="scroll" filters={lazyParams.filters}
        header={(
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-2xl font-bold text-gray-900">Employee Directory</h3>
            {totalRecords > 0 ? (
              <span className="flex items-center px-3 py-1 bg-green-50 text-green-700 rounded-full border border-green-200 text-sm">
                <i className="pi pi-check-circle mr-2"></i>
                {employees.length} of {totalRecords} employees
              </span>
            ) : (
              <span className="flex items-center px-3 py-1 bg-orange-50 text-orange-700 rounded-full border border-orange-200 text-sm">
                <i className="pi pi-exclamation-triangle mr-2"></i>
                No employees found
              </span>
            )}
          </div>
        )}
        globalFilterFields={["firstName", "lastName", "email", "employeeId", "department", "designation"]}
        emptyMessage={<div className="text-center py-8">No employees found</div>}
        className="p-datatable-striped p-datatable-gridlines text-xs" size="small">
        <Column field="id" header="Emp ID" sortable style={{ minWidth: '80px' }} />
        <Column header="Name" body={(rowData) => `${rowData.firstName || ''} ${rowData.lastName || ''}`} sortable style={{ minWidth: '120px' }} />
        <Column field="email" header="Email" style={{ minWidth: '140px' }} />
        <Column field="phone" header="Phone" style={{ minWidth: '100px' }} />
        <Column field="designation" header="Designation" style={{ minWidth: '100px' }} />
        <Column field="joiningDate" header="Joined Date" body={(rd) => rd.joiningDate ? new Date(rd.joiningDate).toLocaleDateString() : '-'} sortable style={{ minWidth: '90px' }} />
        <Column body={actionBodyTemplate} header="Actions" style={{ minWidth: '80px' }} />
      </DataTable>
    </div>
  );
};

export default EmployeesTable;
